import React, { useState } from 'react';
import cx from 'classnames';

import TranslatedCopy from '../../../intl/translated-copy';

import UserProfileAccountNumberForm from './user-profile-account-number-form';

const settingsArray = [{
  id: 1,
  name: 'PRO_HOME_FORGOT_PASSWORD_TITLE',
  details: 'PRO_HOME_FORGOT_PASSWORD_DESCIRPTION',
},
{
  id: 2,
  name: 'PRO_HOME_FORGOT_NIP_TITLE',
  details: 'PRO_HOME_FORGOT_NIP_DESCRIPTION',
},
];

const UserProfileRecoverPasswordPin = (props) => {
  const {
    dispatch,
    pwdPinOptionSelected,
    handleBackButtonClick,
    handleCloseModal,
    toggleRecoveryAccount,
  } = props;

  const [optionSelected, setOptionSelected] = useState(pwdPinOptionSelected);
  const [showPasswordPinResetForm, setShowPasswordPinResetForm] = useState(Boolean(pwdPinOptionSelected));

  const handleSwitch = (id) => {
    setOptionSelected(id);
  };

  const handleRadioModal = () => {
    setShowPasswordPinResetForm(true);
  };

  return (
    showPasswordPinResetForm ?
      <UserProfileAccountNumberForm
        dispatch={ dispatch }
        handleBackButtonClick={ handleBackButtonClick }
        handleCloseModalLogin={ handleCloseModal }
        optionSelected={ optionSelected }
        toggleRecoveryAccount={ toggleRecoveryAccount }
      />
      :
      <div className='UserProfileRecoverPasswordOrPin-container'>
        <button
          className='UserProfileRecoverPasswordOrPin-back'
          onClick={ handleBackButtonClick }
          type='button'>
          <span className='Icon Icon--calendarArrowLeft' />
          <TranslatedCopy
            className='UserProfileRecoverPasswordOrPin-back-Text'
            copyID='PRO_HOME_FORGOT_LOGIN' />
        </button>
        <h6 className='UserProfileRecoverPasswordOrPin-subtitle'>
          <TranslatedCopy copyID='PRO_HOME_FORGOT_TITLE' />
        </h6>
        <div className='UserProfileRecoverPasswordOrPin-radio-container'>
          <ul className='UserProfileRecoverPasswordOrPin-radio-list'>
            { settingsArray.map((value) => {
              const border = cx({
                'UserProfileRecoverPasswordOrPin-list': true,
                'UserProfileRecoverPasswordOrPin-list--selected': optionSelected === value.id,
                'UserProfileRecoverPasswordOrPin-list--notSelected': optionSelected !== value.id && optionSelected !== null,
              });

              return (
                <li key={ value.id } className={ border }>
                  <div className='UserProfileRecoverPasswordOrPin-list-option'>
                    <div className='UserProfileRecoverPasswordOrPin-radio'>
                      <input
                        type='radio'
                        checked={ optionSelected === value.id }
                        id={ value.id }
                        onChange={ () => handleSwitch(value.id) }
                        value={ value.id }
                      />
                      <TranslatedCopy
                        copyID={ value.name }
                        tagName='p' />
                    </div>
                    <TranslatedCopy
                      className='UserProfileRecoverPasswordOrPin-details'
                      copyID={ value.details } />
                  </div>
                </li>
              );
            })}
          </ul>
          <div className='UserProfileRecoverPasswordOrPin-button'>
            <button
              className='Btn'
              disabled={ optionSelected === null }
              onClick={ () => handleRadioModal() }>
              <TranslatedCopy copyID='PRO_HOME_FORGOT_BUTTON' />
            </button>
          </div>
        </div>
        <TranslatedCopy
          className='UserProfileRecoverPasswordOrPin-captcha'
          copyID='PRO_HOME_FORGOT_CAPTCHA'
          tagName='p'
        />
      </div>
  );
};

export default UserProfileRecoverPasswordPin;
